import React from "react";

export const EMPLOYEES_PAGE_TITLE = "Employees";

const roleBadges = {
  org_admin: { bg: "#f3f0ff", color: "#7c3aed", label: "Org Admin" },
  branch_admin: { bg: "#eff6ff", color: "#2563eb", label: "Admin" },
  employee: { bg: "#ecfdf5", color: "#059669", label: "Employee" },
  customer: { bg: "#fff7ed", color: "#d97706", label: "Customer" },
};

const badgeBaseStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  padding: "4px 10px",
  borderRadius: "12px",
  fontSize: "12px",
  fontWeight: 500,
};

function getRoleBadge(person) {
  let key = "employee";
  if (person.type === "customer") key = "customer";
  else if (person.role === "org_admin") key = "org_admin";
  else if (person.role === "branch_admin") key = "branch_admin";

  const badge = roleBadges[key];
  return (
    <span style={{ ...badgeBaseStyle, backgroundColor: badge.bg, color: badge.color }}>
      {badge.label}
    </span>
  );
}

export const employeeTableColumns = [
  {
    key: "name",
    header: "Name",
    wrap: true,
    render: (row) => (
      <>
        <div>
          <strong>{row.first_name} {row.last_name}</strong>
          {row._isCurrentUser && (
            <span style={{ fontWeight: 400, color: "#94a3b8", marginLeft: "6px" }}>(You)</span>
          )}
        </div>
        <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>{row.email}</div>
      </>
    ),
  },
  {
    key: "phone",
    header: "Phone",
    width: "140px",
    hideBelow: "xl",
  },
  {
    key: "role",
    header: "Role",
    width: "120px",
    hideBelow: "lg",
    render: (row) => getRoleBadge(row),
  },
];
